import React from 'react';
import {
    UseControllerProps,
    UseFieldArrayReturn,
    useFieldArray,
    useFormContext,
    FieldValues,
} from 'react-hook-form';

import { Block, Spacer } from '../../layouts';
import { TextCommon } from '../../typo';
import { FormConnector } from '../FormConnector';

export interface FieldArrayProps<T extends FieldValues> {
    readonly name: string;
    readonly isUseWrapper?: boolean;
    readonly label?: string;
    readonly rules?: UseControllerProps['rules'];
    readonly children: (formControl: UseFieldArrayReturn<T>) => React.ReactElement;
}

export function FieldArray<T extends FieldValues>(props: FieldArrayProps<T>) {
    const { label, name, rules, children, isUseWrapper = true } = props;

    const isRequired = !!rules?.required;
    const { control } = useFormContext<T>();

    const fieldArrayReturn = useFieldArray<T>({
        control,
        name: name as any, // type-safe nếu muốn, có thể refine
    });

    const content = (
        <>
            {children(fieldArrayReturn)}
        </>
    );

    return (
        <FormConnector>
            {() => {
                if (isUseWrapper) {
                    return (
                        <Block width="100%">
                            <Spacer bottom={6}>
                                <TextCommon
                                    fontWeight={600}
                                    lineHeight="20px"
                                    translateCode={label}
                                />
                                {isRequired && <span style={{ color: 'red' }}> *</span>}
                            </Spacer>
                            {content}
                        </Block>
                    );
                }
                return content;
            }}
        </FormConnector>
    );
}
